/* @flow */

export const loginPath = '/login/';
